import { printDoc } from '../../lib/print';
import { C } from '../../theme/palette';

export function PhotoSheetA4({ photos, soc, titre, onClose }) {
  const list = (photos || []).filter((p) => p && p.photo);
  return (
    <div
      style={{ height: '100%', display: 'flex', flexDirection: 'column', background: '#5b5f66' }}
    >
      <style>
        {
          '@media print{@page{size:A4;margin:12mm}body *{visibility:hidden}.doc-sheet,.doc-sheet *{visibility:visible}.doc-sheet{position:absolute;left:0;top:0;width:100%;box-shadow:none!important}.doc-noprint{display:none!important}.ph-card{page-break-inside:avoid}}'
        }
      </style>
      <div
        className="doc-noprint"
        style={{
          background: C.navy,
          padding: '10px 14px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            color: '#fff',
            fontSize: 18,
            cursor: 'pointer',
          }}
        >
          ←
        </button>
        <span style={{ fontSize: 11, fontWeight: 700, color: '#fff' }}>Photos · {titre || ''}</span>
        <div style={{ display: 'flex', gap: 6 }}>
          {/*
            Un seul bouton : « Envoyer » imprimait, comme « Imprimer » à côté
            de lui. L'envoi en annexe viendra avec le courrier du serveur.
          */}
          <button
            onClick={printDoc}
            style={{
              background: C.teal,
              border: 'none',
              color: '#fff',
              borderRadius: 8,
              padding: '7px 11px',
              fontSize: 10.5,
              fontWeight: 800,
              cursor: 'pointer',
            }}
          >
            🖨 Imprimer / PDF
          </button>
        </div>
      </div>
      <div
        className="doc-noprint"
        style={{
          background: C.navyXL,
          borderBottom: '1px solid ' + C.border,
          padding: '6px 14px',
          fontSize: 9,
          color: C.muted,
          textAlign: 'center',
          lineHeight: 1.4,
        }}
      >
        Plusieurs photos sur une feuille A4 · 🖨 imprimer ou 📤 partager
      </div>
      <div style={{ flex: 1, overflowY: 'auto', padding: '14px 10px' }}>
        <div
          className="doc-sheet"
          style={{
            maxWidth: 680,
            margin: '0 auto',
            background: '#fff',
            borderRadius: 4,
            padding: '22px 22px',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              borderBottom: '2px solid ' + C.navy,
              paddingBottom: 9,
              marginBottom: 14,
            }}
          >
            <div>
              {soc?.logo ? (
                <img src={soc.logo} alt="" style={{ height: 40, objectFit: 'contain' }} />
              ) : (
                <div style={{ fontSize: 15, fontWeight: 900, color: C.navy }}>
                  {soc?.nom || 'SwissTech'}
                </div>
              )}
            </div>
            <div style={{ textAlign: 'right', fontSize: 8.5, color: C.grey, lineHeight: 1.5 }}>
              {soc?.nom}
              <br />
              {soc?.adr}
              <br />
              {soc?.npa}
            </div>
          </div>
          <div style={{ fontSize: 13, fontWeight: 800, color: C.navy, marginBottom: 12 }}>
            Annexe photos{titre ? ' — ' + titre : ''}
          </div>
          {list.length === 0 ? (
            <div style={{ color: C.muted, fontSize: 11, textAlign: 'center', padding: 40 }}>
              Aucune photo ajoutée
            </div>
          ) : (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 11 }}>
              {list.map((pc, i) => (
                <div
                  key={pc.id || i}
                  className="ph-card"
                  style={{
                    width: 'calc(50% - 6px)',
                    border: '1px solid ' + C.border,
                    borderRadius: 8,
                    overflow: 'hidden',
                    background: '#fafafa',
                  }}
                >
                  <img
                    src={pc.photo}
                    alt=""
                    style={{ width: '100%', height: 188, objectFit: 'cover', display: 'block' }}
                  />
                  {(pc.libelle || (pc.fournisseur && pc.fournisseur !== 'Photo') || pc.date) && (
                    <div style={{ padding: '5px 8px', fontSize: 8, color: C.grey }}>
                      {[
                        pc.libelle || (pc.fournisseur !== 'Photo' ? pc.fournisseur : ''),
                        pc.cat,
                        pc.date,
                      ]
                        .filter(Boolean)
                        .join(' · ')}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
